import { RJSFSchema, UiSchema } from '@rjsf/utils';
import { JsonPlaceholderReplacer } from 'json-placeholder-replacer';
import { parseJson } from 'src/utilities/ApiHelper';
import {
  SchemaAttributes,
  SchemaTranslator,
} from 'src/integration/ddm/DDMSchemaTranslationProvider';
import { CaseCreationStaticSchema } from 'src/components/Forms/CreateCase/CreateCaseSchema';

export class CSAMSchemaTranslator implements SchemaTranslator {
  private coreSchema: RJSFSchema;
  private uiSchema: UiSchema;
  private readonly caseSummarySchema: RJSFSchema;
  private createCaseStaticSchema: CaseCreationStaticSchema;
  private bundles: any;

  constructor(schemaAttributes: SchemaAttributes) {
    this.coreSchema = schemaAttributes.coreSchema;
    this.uiSchema = schemaAttributes.uiSchema;
    this.caseSummarySchema = schemaAttributes.caseSummarySchema;
    this.createCaseStaticSchema = schemaAttributes.createCaseStaticSchema;
    this.bundles = schemaAttributes.bundles;
  }

  translateCoreSchema(): RJSFSchema {
    return this.getPlaceholderReplacedCoreSchema(
      this.coreSchema,
      this.bundles.csamBundle,
    );
  }
  translateUiSchema(): UiSchema {
    return this.getPlaceholderReplacedUiSchema(
      this.uiSchema,
      this.bundles.csamBundle,
    );
  }

  translateCaseSummarySchema(): RJSFSchema {
    return this.caseSummarySchema;
  }

  translateCreateCaseStaticSchema(): CaseCreationStaticSchema {
    return this.createCaseStaticSchema;
  }

  private getPlaceholderReplacedCoreSchema(
    schema: RJSFSchema,
    bundle: any,
  ): RJSFSchema {
    const placeHolderReplacer = new JsonPlaceholderReplacer();
    placeHolderReplacer.addVariableMap({
      case_title_field_name: bundle.getMessage('case_title_field_name'),
      relevant_url_field_name: bundle.getMessage('relevant_url_field_name'),
      relevant_url_field_description: bundle.getMessage(
        'relevant_url_field_description',
      ),
      comments_field_name: bundle.getMessage('comments_field_name'),
      comments_field_description: bundle.getMessage(
        'comments_field_description',
      ),
      declaration_field_text: bundle.getMessage('declaration_field_text'),
    });

    return placeHolderReplacer.replace(parseJson(JSON.stringify(schema)));
  }

  private getPlaceholderReplacedUiSchema(
    schema: UiSchema,
    bundle: any,
  ): UiSchema {
    const placeHolderReplacer = new JsonPlaceholderReplacer();

    placeHolderReplacer.addVariableMap({
      mandatory_field_error_message: bundle.getMessage(
        'mandatory_field_error_message',
      ),
      invalid_eu_8_url_field_error_message: bundle.getMessage(
        'invalid_eu_8_url_field_error_message',
      ),
      accept_tnc_field_error_message: bundle.getMessage(
        'accept_tnc_field_error_message',
      ),
    });

    return placeHolderReplacer.replace(parseJson(JSON.stringify(schema)));
  }
}
